import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import { KeyEventUtil } from 'utils'

const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting, handleChange, montosFormRef }) => {
  const [monedasOptions, setMonedasOptions] = React.useState([])

  React.useEffect(() => {
    setMonedasOptions(
      MonedasConstant.__array.map((x, k) => (
        <option key={k} value={x.id}>
          {x.nombre}
        </option>
      ))
    )
  }, [])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('input-importe', e)
  }, [])

  const onChange = React.useCallback(
    e => {
      handleChange(e)

      if (montosFormRef && montosFormRef.current) {
        montosFormRef.current.setFieldValue('simboloMoneda', e.target.value || MonedasConstant.SOLES)
      }
    },
    [handleChange, montosFormRef]
  )

  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-moneda' md={5} alignRightAt='md' />
      <Col md={7}>
        <Field name='moneda'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-moneda'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
              onChange={onChange}
            >
              <option value=''> Seleccionar... </option>
              {monedasOptions}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
